const initialState = {
    LoginData: [],
    UserData: [],
    TableData: [],
    inboxFaxData: [],
    labelFaxData: [],
    loginUserData: []
}

export default initialState;